export const previewModeStorageKeyPrefix = 'trackingPagePreviewMode'
